// Copyright (c) 2016 Deere & Company

import actions from '../../action-list';
import {routerActions} from 'react-router-redux';

export const copyClaim = claim =>
    dispatch => {

        dispatch({
            data: claim,
            isCopied: true,
            type: actions.COPY_CLAIM_SPA
        });

        dispatch(routerActions.replace('/claims/spa/new/'));

    };



// WEBPACK FOOTER //
// ./src/claim/spa/action-creators/copy-claim.js